<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               :append-to-body="true"
               custom-class="window"
               width="960px"
               top="5vh"
               :before-close="()=>{this.closeDialog()}"
               :show-close="false"
               title="Conflict Product Installation Tasks">
      <div v-if="tasks.length>0"
           style="text-align:center;margin-bottom:10px;">
        <el-button size="mini"
                   type="primary"
                   v-has="'Edit Task'"
                   :disabled="this.canUpdateTasks.length===0 || updateLoading"
                   @click="handleTaskUpdateAll()">Update All ({{this.canUpdateTasks.length}})</el-button>
        <el-button size="mini"
                   type="danger"
                   v-has="'Delete Task'"
                   :disabled="updateLoading"
                   @click="handleTaskDeleteAll()">Delete All ({{this.tasks.length}})</el-button>
      </div>
      <div v-if="this.tasks.length>0">
        <el-table :data="tasks"
                  style="margin-bottom:20px"
                  size="small">
          <el-table-column prop="Name"
                           label="Task Name"
                           width="180">
          </el-table-column>
          <el-table-column label="Conflict Descirption"
                           width="560">
            <template slot-scope="scope">
              <div v-for="description in scope.row.Descriptions"
                   :key="description.TaskId + '_' + description.ShapeId">
                <div v-if="description.ConflictType === 0">
                  {{ description.ShapeName }} was deleted.
                </div>
                <div v-if="description.ConflictType === 1">
                  {{ description.SKU }} was removed from the <span>{{getAssignType(description.AssignType)}}</span> of
                  <span>{{description.ShapeName}}</span>.
                </div>
                <div v-if="description.ConflictType === 2">
                  {{getNetAreaText(description.IsAreaProduct)}} of <span>{{description.SKU}}</span> was changed from <span>{{description.OldNetArea}}</span>
                  to <span>{{description.NewNetArea}}</span> on the <span>{{getAssignType(description.AssignType)}}</span> of <span>{{description.ShapeName}}</span>.
                </div>
                <div v-if="description.ConflictType === 3">
                  New product {{ description.SKU }} ({{getNetAreaText(description.IsAreaProduct)}}: <span>{{description.NetArea}}</span>) added to <span>{{getAssignType(description.AssignType)}}</span> on
                  <span>{{description.ShapeName}}</span>.
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Action"
                           label="Action">
            <template slot-scope="scope">
              <span style="display:inline-block;margin-right:12px;width:70px;">
                <el-button size="mini"
                           v-if="scope.row.TaskType === 4 && roomAssignments.find(i => i.RoomId === scope.row.RoomId) &&
                            roomAssignments.find(i => i.RoomId === scope.row.RoomId).Assignments.length > 0"
                           v-has="'Edit Task'"
                           type="primary"
                           :disabled="updateLoading"
                           @click="handleOneToManyTaskUpdate(scope.row)">Update</el-button>
              </span>
              <el-button size="mini"
                         v-has="'Delete Task'"
                         type="danger"
                         :disabled="updateLoading"
                         @click="handleTaskDelete(scope.row.TaskId)">Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeDialog"
                   size="small">Close</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { deleteTask, updateConflictTasks } from '@/api/config'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    conflictTasks: {
      type: Array,
      default: null
    },
    conflictRoomAssignments: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      hasChange: false,
      updateLoading: false,
      tasks: this.conflictTasks,
      roomAssignments: this.conflictRoomAssignments
    }
  },
  computed: {
    getNetAreaText () {
      return function (isAreaProduct) {
        return isAreaProduct ? 'Net Area' : 'Qty'
      }
    },
    getAssignType () {
      return function (assignType) {
        switch (assignType) {
          case 0:
            return ' floor'
          case 2:
            return ' base'
          case 1:
            return ' wall'
          case 3:
            return ' door'
        }
      }
    },
    ...mapState(['jobsiteID', 'plan']),
    canUpdateTasks () {
      let updateTasks = []
      updateTasks.push.apply(updateTasks, this.tasks.filter(q => q.TaskType === 4 && this.roomAssignments.find(i => i.RoomId === q.RoomId) && this.roomAssignments.find(i => i.RoomId === q.RoomId).Assignments.length > 0))
      return updateTasks
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
    conflictTasks (newValue) {
      this.tasks = newValue
    },
    roomAssignments (newValue) {
      this.roomAssignments = newValue
    },
    showDialog (newValue) {
      if (newValue) {
        this.hasChange = false
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog', this.hasChange)
    },
    updateCallback (obj) {
      if (obj instanceof Array) {
        for (let taskId of obj) {
          let index = this.tasks.findIndex(q => q.TaskId === taskId)
          this.tasks.splice(index, 1)
        }
      } else {
        let index = this.tasks.findIndex(q => q.TaskId === obj)
        this.tasks.splice(index, 1)
      }
      this.hasChange = true
      this.updateLoading = false
      if (this.tasks.length === 0) {
        this.closeDialog()
      }
    },
    getTaskShapeId (prod) {
      let owner = prod.owner
      while (owner) {
        if (owner.id) {
          return owner.id
        }
        owner = owner.parentShape
      }
    },
    getRegionPerimeter (owner) {
      if (owner.region) {
        return owner.region.perimeter
      } else if (owner.parentShape.region) {
        return owner.parentShape.region.perimeter
      }
      return 0
    },
    getHandleInvisibleTasks (task) {
      let roomAssignments = this.roomAssignments.find(q => q.RoomId === task.RoomId)
      let assignments = roomAssignments.Assignments
      let invisibleTaskList = []
      for (let i of assignments) {
        if (i.prod && this.$config.IsTrackableProduct(i)) {
          if (!invisibleTaskList.find(q => q.id === i.prod.id && q.assignType === i.TaskAssignType)) {
            invisibleTaskList.push({ id: i.prod.id, assignType: i.TaskAssignType })
          }
        }
      }
      let returnTasks = []
      invisibleTaskList.forEach(item => {
        let obj = {}
        const id = uuid.v4()
        obj.TaskId = id
        let TaskProductObj = {
          SKU: item.id,
          ProjectId: this.plan.LinkProjectId,
          Quantity: 0.0,
          TotalQty: 0,
          TaskId: id
        }
        let arrShape = []
        assignments.forEach(res => {
          let TaskShapesObj = {}
          if (res.prod &&
            res.prod.id === item.id &&
            res.TaskAssignType === item.assignType) {
            TaskProductObj.Quantity += res.usage
            TaskProductObj.TotalQty += res.netArea
            if (res.locationType) {
              obj.LocationType = res.locationType
            }
            obj.ProductType = res.type
            TaskShapesObj.ShapeId = this.getTaskShapeId(res)
            TaskShapesObj.ShapeName = roomAssignments.RoomName
            TaskShapesObj.RoomShapeId = task.RoomId
            TaskShapesObj.ShapeType = 0
            if (res.type === 1) {
              TaskShapesObj.ShapePerimeter = this.getRegionPerimeter(res.owner)
            }
            if (res.type === 2 || res.type === 3) {
              TaskShapesObj.ShapePerimeter = res.netArea
            }
            TaskShapesObj.ShapeArea = res.netArea
            arrShape.push(TaskShapesObj)
          }
        })
        obj.TaskShapes = arrShape
        obj.TaskProduct = TaskProductObj
        obj.AssignType = item.assignType
        obj.JobsiteId = this.jobsiteID
        obj.RoomId = task.RoomId
        obj.PlanId = this.plan.PlanId
        obj.LayerShapeId = this.plan.LinkLayerShapeId
        obj.Name = item.id
        obj.LocationX = 0.0
        obj.LocationY = 0.0
        obj.TaskType = 3
        obj.ParentTaskId = task.TaskId
        returnTasks.push(obj)
      })
      return returnTasks
    },
    handleOneToManyTaskUpdate (task) {
      let postTasks = this.getHandleInvisibleTasks(task)
      if (postTasks.length > 0) {
        let that = this
        this.updateLoading = true
        updateConflictTasks(postTasks).then(res => {
          that.updateCallback(task.TaskId)
        })
      }
    },
    getHandleNormalProductIntallTask (task) {
      let newSKU = task.AffectTasks[0].NewAssignments[0].prod.id
      let total = 0
      let quantity = 0
      let arrShape = []
      for (let assigment of task.AffectTasks[0].NewAssignments) {
        total += assigment.netArea
        quantity += assigment.usage
        arrShape.push({
          ShapeId: this.getTaskShapeId(assigment),
          RoomShapeId: assigment.roomId,
          ShapeName: assigment.roomName,
          ShapeArea: assigment.netArea,
          ShapePerimeter: assigment.netArea
        })
      }
      let obj = {}
      obj.TaskId = task.TaskId
      obj.JobsiteId = this.jobsiteID
      obj.Name = task.Name
      obj.TaskType = task.TaskType
      obj.TaskProduct = {
        SKU: newSKU,
        TotalQty: total,
        Quantity: quantity
      }
      obj.TaskShapes = arrShape
      return obj
    },
    handleNormalProductIntallTaskUpdate (task) {
      let obj = this.getHandleNormalProductIntallTask(task)
      let that = this
      this.updateLoading = true
      updateConflictTasks([obj]).then(res => {
        that.updateCallback(task.TaskId)
      })
    },
    handleTaskDelete (taskId) {
      let that = this
      this.$confirm(this.$t('taskDialog.AreYouSureYouWantToDeleteThisTask'), this.$t('taskDialog.TIPS'), {
        confirmButtonText: this.$t('taskDialog.Yes'),
        cancelButtonText: this.$t('taskDialog.No'),
        type: 'warning'
      }).then(() => {
        let params = []
        params.push(taskId)
        this.updateLoading = true
        deleteTask(params).then(res => {
          that.updateCallback(taskId)
        })
      })
    },
    handleTaskUpdateAll () {
      let that = this
      this.$confirm('Are you sure you want to update all updatable tasks?', this.$t('taskDialog.TIPS'), {
        confirmButtonText: this.$t('taskDialog.Yes'),
        cancelButtonText: this.$t('taskDialog.No'),
        type: 'warning'
      }).then(() => {
        let updateTasks = []
        for (let task of that.canUpdateTasks) {
          if (task.TaskType === 1) {
            updateTasks.push(that.getHandleNormalProductIntallTask(task))
          } else if (task.TaskType === 4) {
            updateTasks.push.apply(updateTasks, that.getHandleInvisibleTasks(task))
          }
        }
        this.updateLoading = true
        updateConflictTasks(updateTasks).then(res => {
          that.updateCallback(that.canUpdateTasks.map(q => { return q.TaskId }))
        })
      })
    },
    handleTaskDeleteAll () {
      let that = this
      this.$confirm('Are you sure you want to delete all these tasks?', this.$t('taskDialog.TIPS'), {
        confirmButtonText: this.$t('taskDialog.Yes'),
        cancelButtonText: this.$t('taskDialog.No'),
        type: 'warning'
      }).then(() => {
        let taskIds = this.tasks.map(q => { return q.TaskId })
        this.updateLoading = true
        deleteTask(taskIds).then(res => {
          that.updateCallback(taskIds)
        })
      })
    }
  },
  components: {

  }
}
</script>
